<template>
  <div class="widget" v-show="show">
    <!-- <div class="widget-navbar">
      <p>Faça uma doação</p>
      <a v-show="closeModal" @click="show = false"
        ><i class="fal fa-times"></i
      ></a>
    </div>-->
    <div class="widget-slick" @scroll="checkScroll">
      <button class="prev" @click="prev" v-if="donationProducts && donationProducts.length > 1 && checkoutSimplifiedOpenValue">
        <i class="fas fa-chevron-left"></i>
      </button>
      <button class="next" @click="next" v-if="donationProducts && donationProducts.length > 1 && checkoutSimplifiedOpenValue">
        <i class="fas fa-chevron-right"></i>
      </button>
      <template v-for="donationProduct in donationProducts">
        <div
          v-show="!hideWidgetHeader"
          class="widget-header"
          :style="`background-image: url(${donationProduct.file.path})`"
          :key="donationProduct.id"
          :data-id="donationProduct.id"
        >
          <!-- <div class="widget-header-logo">
            <img :src="landingPageOptions.logo.path" alt />
          </div> -->
          <div></div>
          <div class="widget-header-info">
            <div v-if="!otherValue">
              <h4>{{ donationProduct.suggestionValue }}</h4>
              <div class="widget-header-title">
                <p>{{ donationProduct.name }}</p>
                <!-- <span v-if="donationProduct.description">
                  <i class="fal fa-plus-circle"></i>
                  <i class="fal fa-minus-circle"></i>
                </span>-->
              </div>
              <span
                class="widget-header-description active"
                v-if="donationProduct.description"
              >{{ donationProduct.description }}</span>
            </div>
            <div v-else-if="otherValue && checkoutSimplifiedOpenValue">
              <div class="widget-header-title">
                <p>{{ donationProduct.name }}</p>
              </div>
              <span
                class="widget-header-description active"
                v-if="donationProduct.description"
              >{{ donationProduct.description }}</span>
            </div>
            <div class="widget-header-info" v-else-if="otherValue && !checkoutSimplifiedOpenValue">
              <h4>Escolha outro valor</h4>
              <span class="widget-header-description active">
                Escolha o valor que deseja doar.
              </span>
            </div>
          </div>
        </div>
      </template>
    </div>
   <div class="widget-buttons" v-if="!checkoutSimplifiedOpenValue">
     <button @click="prevButtons()">
       <i class="fal fa-chevron-left"></i>
     </button>
    <div class="widget-values" v-show="step !== 3">
      <template v-for="(donationProduct, index) in donationProducts">
        <div :key="donationProduct.id">
          <button
            @click="cartDonationValue(donationProduct, index)"
            :class="{
              active: itemSelected.id == donationProduct.id,
            }"
            :data-value-id="donationProduct.id"
          >
            <div
            @click="$gtag('send', 'event', 'Botão com o valor a doar', 'Botão com o valor a doar', donationProduct.fixedValue)"
              v-if="
                donationProduct.fixedValue != null &&
                donationProduct.fixedValue != 0 &&
                !donationProduct.openValue
              "
            >{{ donationProduct.fixedValue | FormatMoney }}</div>
            <div
            @click="$gtag('send', 'event', 'Botão com o valor a doar', 'Botão com o valor a doar', donationProduct.suggestionValue)"
              v-else-if="
                donationProductValue(donationProduct.suggestionValue) != '' &&
                !donationProduct.openValue
              "
            >
              {{
                donationProductValue(donationProduct.suggestionValue)
                  | FormatMoney
              }}
            </div>
            <div 
              @click="$gtag('send', 'event', 'Botão com o valor a doar', 'Botão com o valor a doar', 'Outros Valores');
              selectOtherValue()" 
              v-else>Outros valores</div>
          </button>
        </div>
      </template>
    </div>
    <button @click="nextButtons()">
      <i class="fal fa-chevron-right"></i>
    </button>
   </div>
   <div class="otherInput" v-if="donationSelected.goal">
      <template v-for="(donationProduct) in donationProducts" >
        <v-layout justify-space-between 
          :key="donationProduct.id" 
          :style="{
            display: donationSelected.id === donationProduct.id ? '' : 'none'
          }" 
          v-if="donationSelected.goal">
          <v-flex shrink>
            <small>
              Captação total: <b :title="formatterHelper.formatMoney(getGoalsReached(donationProduct.id))">R$ {{ formatterHelper.formatShortNumber(getGoalsReached(donationProduct.id)) }}</b>
            </small>
          </v-flex>
          <v-flex shrink>
            <small>
              Objetivo: <b :title="formatterHelper.formatMoney(getGoalsValue(donationProduct.id))">R$ {{ formatterHelper.formatShortNumber(getGoalsValue(donationProduct.id)) }}</b>
            </small>
          </v-flex>
        </v-layout>
        <div class="progress-bar" :style="{
            display: donationSelected.id === donationProduct.id ? '' : 'none'
          }" :key="donationProduct.id">
          <span :style="{width: getGoalProgressBar(donationProduct.id)}"></span>
        </div>
    </template>
    </div>
    <div class="otherInput" v-if="otherValue">
      <label>Informe o valor da doação</label>
      <div class="widget-header-input">
        <InputMoney
            v-if="!btnOtherValue"
            v-model="cartItem.itemValue"
            :precision="0"
            suffix=",⁰⁰"
            :prefix="R$"
            ref="toInputMoney"
            :pattern="'\\d*'"
            :autoFocusOnValidationFail="false"
            invalidInputMessage="Preencha o valor da doação"
            @blur="
              setFocused($event, false);
            "
            @focus="setFocused($event, true)"
          />
      </div>
      <p class="f-size-11 color-theme-texto" v-if="campaignLandingPageConfig.campaign.minimumDonationValue > 0">
        O valor mínimo desta campanha é <span> {{ this.formatterHelper.formatMoneyWithCents(campaignLandingPageConfig.campaign.minimumDonationValue) }}</span>
        </p>
    </div>
    <div class="widget-content">
      <Payment
        v-show="step === 1"
        :payments="payments"
        :payment="payment"
        :hideDonationTypeLabel="isSingleUniqueRecurrence"
        @onSelectPayment="selectPayment($event)"
        @onContinue="goToForm($event)"
      />
      <Form
        ref="formComponent"
        v-show="step === 2"
        :payment="payment"
        :fields="fields"
        @onContinue="goToForm($event)"
        @onChangePayment="payment = $event"
        :cartItem="cartItem"
        :campaignLandingPageConfig="campaignLandingPageConfig"
        :project="project"
        v-on:minimumPeriodDonationValue="GetMinimumPeriodDonationValue($event)"
        @recurrenceLoaded="isSingleUniqueRecurrence = $event"
      ></Form>
      <Success v-show="step === 3" :payment="payment"></Success>
      <div class="widget-secure">
        <span class="widget-secure-label">Sua doação é 100% segura.</span>
        <span class="widget-secure-ssl">
          <i class="fal fa-lock"></i>
          SSL
        </span>
      </div>
      <div class="widget-footer">
        <span>©{{ new Date().getFullYear() }} • AUC</span>
        <span>
          <a @click="showPolicyTerms = true">Política de Privacidade</a> e
          <a @click="showServiceTerms = true">Termos de Uso</a>.
        </span>
      </div>
    </div>
    <div class="widget-loading" v-show="loading"></div>
    <div class="widget-snackbar" v-show="error">
      <i class="fas fa-exclamation-triangle"></i>
      <p class="message">Erro de conexão. Por favor tente novamente mais tarde.</p>
      <a @click="error = false">
        <i class="fal fa-times"></i>
      </a>
    </div>
    <UseTermsModal v-model="showServiceTerms" @close="showServiceTerms = false"></UseTermsModal>
    <PrivacyPolicyTermsModal v-model="showPolicyTerms" @close="showPolicyTerms = false"></PrivacyPolicyTermsModal>
  </div>
</template>

<script>
/* 
Modos de pagamento
Valores + opção de outro valor
Campos opcionais do cartão de crédito 
  CPF
  Estado
  Nome no cartão
ID da instituição
Se eh um modal

?payments=card,barcode,apple,google&values=10,50,100,500,-1&fields=name,email,cpf,state,cardname&id=1&type=modal
*/
import Payment from "./Payment.vue";
import Form from "./Form.vue";
import Success from "./Success.vue";
import CartItem from "@/scripts/models/cartItem.model";
import Project from "@/scripts/models/project.model";
import DonationProduct from "@/scripts/models/donationProduct.model";
import ProjectService from "@/scripts/services/project.service";
import UseTermsModal from "@/components/UseTermsModal.vue";
import PrivacyPolicyTermsModal from "@/components/PrivacyPolicyTermsModal.vue";
import CommonHelper from "@/scripts/helpers/common.helper";
import PaymentMethod from '../../../../scripts/models/enums/paymentMethod.enum';
import FormatterHelper from "@/scripts/helpers/formatter.helper";

export default {
  components: {
    Payment,
    Form,
    Success,
    UseTermsModal,
    PrivacyPolicyTermsModal,
  },
  props: {
    campaignLandingPageConfig: { default: null },
    landingPageOptions: { default: null },
    projectId: { default: null },
    hideWidgetHeader: { type: Boolean, default: false },
  },
  data() {
    return {
      formatterHelper: new FormatterHelper(),
      projectService: new ProjectService(),
      step: 1,
      showServiceTerms: false,
      showPolicyTerms: false,
      payments: [],
      show: true,
      closeModal: false,
      loading: false,
      error: false,
      fields: [],
      project: new Project(),
      cartItem: new CartItem(),
      donationProducts: [],
      otherValue: false,
      btnOtherValue: false,
      itemSelected: new DonationProduct(),
      payment: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      other: [{ id: 1, type: "other", file: { path: "" } }],
      timer: null,
      minimumPeriodDonationValue: 0,
      CommonHelper: CommonHelper,
      checkoutSimplifiedOpenValue: false,
      goals: null,
      isSingleUniqueRecurrence: false,
    };
  },
  computed: {
    donationSelected() {
      return this.itemSelected;
    }
  },
  watch: {
    campaignLandingPageConfig() {
      this.payments = this.campaignLandingPageConfig.campaign.paymentMethodList;
    },
    itemSelected(value){
      this.goal = value.goal;
      this.reached = this.getGoalsReached(value.id);
    }
  },
  async created() {
    if (this.campaignLandingPageConfig) {
      this.cartItem.project = this.project;
      this.payments = this.campaignLandingPageConfig.campaign.paymentMethodList;
      this.checkoutSimplifiedOpenValue = this.campaignLandingPageConfig.campaign.checkoutSimplifiedOpenValue;
      this.loadDonationProducts();
      await this.loadDonationProductsGoals();
    }
  },
  methods: {
    CheckMinimumValue() {
      if (this.cartItem.itemValue < this.minimumPeriodDonationValue) {
        this.CommonHelper.swal(
          "Desculpe, você está doando um valor inferior ao mínimo permitido nessa campanha"
        );
        //this.cartItem.itemValue = this.minimumPeriodDonationValue;
      }
    },
    GetMinimumPeriodDonationValue(value) {
      this.minimumPeriodDonationValue = value;
    },
    loadDonationProducts() {
      if(!this.projectId)
        this.projectService.listAllDonationProductsByCampaignId(this.loadDonationProducts_Callback, this.campaignLandingPageConfig.campaignId);
      else
        this.projectService.listDonationProductByProjectId(this.projectId).then(this.loadDonationProducts_Callback)
    },
    async loadDonationProductsGoals() {
      let goals = null
      if(!this.projectId)
        goals = await this.projectService.listAllDonationProductsGoalsByCampaignId(this.campaignLandingPageConfig.campaignId);
      else
        goals = await this.projectService.ListAllDonationProductsGoalsByCampaignId(this.projectId)

      this.goals = goals
    },
    loadDonationProductsGoals_Callback(data) {
      this.goals = data;
    },
    getGoalsValue(donationProductId) {
      if(this.goals?.length) {
        return this.goals.find(x => x.donationProductId === donationProductId).goal;
      }
      return null;
    },
    getGoalsReached(donationProductId) {
      if(this.goals?.length) {
        const goal = this.goals.find(x => x.donationProductId === donationProductId);
        return goal.reached;
      }
      return null;
    },
    getGoalProgressBar(donationProductId) {
      if(this.goals?.length) {
        const goal = this.goals.find(x => x.donationProductId === donationProductId);
        const total = (goal.reached / goal.goal) * 100
        return total > 0 ? (goal.reached / goal.goal) * 100 + '%' : '0%';
      }
      return null;

    },
    loadDonationProducts_Callback(data) {
      console.log("data", data)
      this.donationProducts = data.filter(x => x.active);
      console.log("actives", this.donationProducts)

      const configuredOrder = this.applyConfiguredOrder(this.donationProducts);
      if (configuredOrder) {
        // Ordem/seleção definida pelo gestor no editor (Hero Checkout) tem prioridade.
        this.donationProducts = configuredOrder;
      } else {
      // Ordena os produtos de doação por valor sugerido de forma decrescente
      if (this.campaignLandingPageConfig.campaignId === 651){
        // Retira todos os objetos openValue = true e os insere no fim depois da ordenação
        const openValues = this.donationProducts.filter(x => x.openValue);
        this.donationProducts = this.donationProducts.filter(x => !x.openValue);
        this.donationProducts = this.donationProducts.sort((a, b) => {
          return b.fixedValue - a.fixedValue;
        });
        this.donationProducts = this.donationProducts.concat(openValues);
      }

      if (this.campaignLandingPageConfig.campaignId === 656) {
        const idx1912 = this.donationProducts.findIndex(x => x.id === 1912);
        if (idx1912 !== -1) {
          const [product1912] = this.donationProducts.splice(idx1912, 1);
          this.donationProducts.unshift(product1912);
        }

        const idx2182 = this.donationProducts.findIndex(x => x.id === 2182);
        if (idx2182 !== -1) {
          const [product2182] = this.donationProducts.splice(idx2182, 1);
          this.donationProducts.unshift(product2182);
        }
      }
      // Produto dia das crianças em primeiro na campanha da Claro
      if(this.donationProducts.map(x => x.id).includes(1966)
          || this.donationProducts.map(x => x.id).includes(1988) 
          || this.donationProducts.map(x => x.id).includes(2034)
          || this.donationProducts.map(x => x.id).includes(2148)
          || this.donationProducts.map(x => x.id).includes(2166)) {
        const index = this.donationProducts.findIndex(x => x.id === 1966 || x.id === 1988 || x.id === 2034 || x.id === 2148 || x.id === 2166);
        if (index !== -1) {
          const [product] = this.donationProducts.splice(index, 1);
          this.donationProducts.unshift(product);
        }
      }
      }
      console.log("ordenados", this.donationProducts)
      if(this.$route.query.campanha) {
        const product = this.donationProducts.find(x => x.customUrl == this.$route.query.campanha);
        if(product) {
          const productIndex = this.donationProducts.indexOf(product);
          this.cartDonationValue(product, productIndex);
          setTimeout(() => this.goTo(productIndex), 500);
        }
      } else {
        this.cartDonationValue(this.donationProducts[0], 0);
        setTimeout(() => this.goTo(0), 500);
      }
    },
    // Aplica a seleção/ordem de produtos definida no editor (heroCheckoutDonationProductOrder).
    // Retorna o array ordenado (whitelist estrita) ou null para usar a ordenação padrão/legada.
    applyConfiguredOrder(products) {
      const raw = this.campaignLandingPageConfig.heroCheckoutDonationProductOrder;
      if (!raw) return null;

      let orderIds;
      try {
        orderIds = JSON.parse(raw);
      } catch (e) {
        return null;
      }
      if (!Array.isArray(orderIds) || !orderIds.length) return null;

      const byId = new Map(products.map(p => [p.id, p]));
      const ordered = orderIds.map(id => byId.get(id)).filter(Boolean);
      return ordered.length ? ordered : null;
    },
    selectPayment(e) {
      this.payment = e;
      this.goToForm(2);
      this.changePaymentInfoDOM(e)
    },
    changePaymentInfoDOM(paymentMethod) {
       const evento = new CustomEvent('payment-method-update', {
        detail: { component: 'SimplifiedCheckout', property: 'payment-method', value: paymentMethod }
      });
      document.dispatchEvent(evento);
    },
    goToForm(e) {
      this.step = e;
    },
    cartDonationValue(item, index) {
      if(!item) return;
      this.btnOtherValue = false;
      this.otherValue = false;
      this.itemSelected = item;

      if (item && item.fixedValue != null && !item.openValue) {
        this.cartItem.itemValue = item.fixedValue;

      } else if (
        item &&
        this.donationProductValue(item.suggestionValue) != "" &&
        !item.openValue
      ) {
        this.cartItem.itemValue = this.donationProductValue(
          item.suggestionValue
        );

      } else {
        this.otherValue = true;
        this.cartItem.itemValue = 0;
      }

      this.cartItem.donationProductId = item.id;
      this.cartItem.donationProduct = item;
      this.cartItem.donationProduct.currentQuantity = 1;
      this.cartItem.project = item.project;
      this.cartItem.projectId = item.project.id;
      this.project = item.project;
      this.goTo(index);
      this.emitDOMEvent(item);

      this.$nextTick(() => {
        if (this.$refs.formComponent && this.$refs.formComponent.recalcParcelamentImmediate) {
          this.$refs.formComponent.recalcParcelamentImmediate();
        }
      });
    },
    emitDOMEvent(item) {
      const evento = new CustomEvent('donation-product-update', {
        detail: { component: 'SimplifiedCheckout', property: 'donation-product', value: item.name }
      });
      document.dispatchEvent(evento);
    },
    selectOtherValue() {
      this.btnOtherValue = true;
      this.otherValue = true;
      this.itemSelected = new DonationProduct();
      this.goTo(this.donationProducts.length);
    },
    donationProductValue(value) {
      let matches = String(value).match(/[\d.,]+/g);
      if (!matches || matches.length == 0) return "";
      let ret = matches[0].replace(".", "").replace(",", ".");
      return parseFloat(ret);
    },
    next() {
      let slick = document.querySelector(".widget-slick");
      let width = document.querySelector(".widget-slick > div").offsetWidth;
      let actualIndexItem = this.donationProducts.indexOf(this.itemSelected);

      slick.scrollLeft = slick.scrollLeft + width;

      if (this.donationProducts.length > actualIndexItem + 1) actualIndexItem++;
      else actualIndexItem = 0;
      this.cartDonationValue(
        this.donationProducts[actualIndexItem],
        actualIndexItem
      );
    },
    prev() {
      let slick = document.querySelector(".widget-slick");
      let width = document.querySelector(".widget-slick > div").offsetWidth;
      let actualIndexItem = this.donationProducts.indexOf(this.itemSelected);

      slick.scrollLeft = slick.scrollLeft - width;

      if (actualIndexItem - 1 >= 0) actualIndexItem--;
      else actualIndexItem = this.donationProducts.length - 1;
      this.cartDonationValue(
        this.donationProducts[actualIndexItem],
        actualIndexItem
      );
    },
    prevButtons() {
      let slick_buttons = document.querySelector(".widget-values");
      if(slick_buttons) {
        slick_buttons.scrollLeft = slick_buttons.scrollLeft -= 100
      }
      this.prev();
    },
    nextButtons() {
      let slick_buttons = document.querySelector(".widget-values");
      if(slick_buttons) {
        slick_buttons.scrollLeft = slick_buttons.scrollLeft += 100
      }
      this.next();
    },
    checkScroll(e) {
      let slick = document.querySelector(".widget-slick");
      let divs = document.querySelectorAll(".widget-slick .widget-header");
      let id;
      let left = slick.scrollLeft;
      let slick_buttons = document.querySelector(".widget-values");
      let actualIndexItem = this.donationProducts.indexOf(this.itemSelected);
      var _this = this;

      if (this.timer !== null) {
        clearTimeout(this.timer);
      }

      // return false;
      this.timer = setTimeout(function () {
        for (let i = 0; i < divs.length; i++) {
          if (divs[i].offsetLeft >= left && divs[i].offsetLeft <= left + 5) {
            actualIndexItem = i;
          }
        }
        id = divs[actualIndexItem].getAttribute("data-id");
        let btn = document.querySelector(`button[data-value-id="${id}"]`);
        if (btn) {
          slick_buttons.scrollLeft = btn.offsetLeft - 70;
          _this.cartDonationValue(
            _this.donationProducts[actualIndexItem],
            actualIndexItem
          );
        }
        if (divs[actualIndexItem].querySelector('.widget-header-input input')) divs[actualIndexItem].querySelector('.widget-header-input input').focus()
      }, 150);
    },
    goTo(index) {
      let slick = document.querySelector(".widget-slick");
      let width = "";
      if (document.querySelector(".widget-slick > div")) {
        width = document.querySelector(".widget-slick > div").offsetWidth;
      }
      slick.scrollLeft = width * index;
    },
    prevBtns() {
      document.querySelector('.widget-values').scrollLeft -= 130
    },
    nextBtns() {
      document.querySelector('.widget-values').scrollLeft += 130
    },
    openDescription(e) {
      e.target.classList.toggle("open");
      e.target.parentElement
        .querySelector(".widget-header-description")
        .classList.toggle("active");
    },
    setFocused(e, focus) {
      let parent = e.target.parentElement.parentElement.parentElement;
      if (focus) {
        parent.classList.add('focused')
      } else {
        parent.classList.remove('focused')
      }
    }
  },
};
</script>
<style>
.widget-slick {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  scroll-behavior: smooth;
  -ms-scroll-snap-type: x mandatory;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}
.widget-slick > div {
  flex: none;
  width: 100%;
  scroll-snap-align: start;
}
.widget-slick::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.widget-slick .next,
.widget-slick .prev {
  position: absolute;
  color: white;
  font-size: 15px;
  z-index: 9;
  background: rgb(var(--theme-primaria));
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -1rem;
}
.widget-slick .prev {
  left: 1rem;
}
.widget-slick .next {
  right: 1rem;
}
.widget-header-description {
  font-size: 16px;
  opacity: 0;
  height: 0px;
  transition: all 0.3s;
  overflow: hidden;
  display: block;
}
.widget-header-description.active {
  height: auto;
  opacity: 1;
}
.widget button.widget-btn {
  background-color: rgba(var(--theme-primaria)) !important;
}
.btn-control {
  width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0 !important;
  background: #f5f6fa;
  font-size: 20px;
  color: #4C4D4F;
}
</style>